import { itemStdWidth } from "../data/main";

const getWindowDimensions = () => {
  const { clientWidth: width, clientHeight: height } = document.documentElement;
  return {
    width,
    height,
  };
};

export const getMenuWidth = () => {
  const { width } = getWindowDimensions();
  let units = Math.trunc(width / itemStdWidth);
  let tempWidth = width - (30 + (units - 1) * 15);
  return tempWidth / units - 0.5;
};
